/* Logique métier des devis — reprise à l'identique de l'ancien Admin.jsx.
   Aucun calcul ni aucun texte n'a été modifié ici. */

export const StatusLabels = {
  sent: '📬 Demande envoyée',
  received: '📤 Demande reçue',
  in_progress: '⚙️ Prise en charge',
  ready: '✅ Devis envoyé',
}

export const StatusTone = {
  sent: 'amber',
  received: 'blue',
  in_progress: 'gold',
  ready: 'green',
}

export const STATUS_ORDER = ['sent', 'received', 'in_progress', 'ready']

/* ── Marchandise demandée ──
   Les produits du catalogue se déclinent (Prairie naturelle, Orge, Blé,
   défibrée…) mais se rangent en trois familles, celles dont on parle au
   téléphone. Un devis peut appartenir à plusieurs. */
function estDefibree(p) {
  return p.includes('défibr') || p.includes('defibr')
}

export const CATEGORIES = [
  { key: 'foin', label: '🌿 Foin', reconnait: (p) => p.includes('foin') },
  { key: 'luzerne', label: '🌱 Luzerne', reconnait: (p) => p.includes('luzerne') },
  /* La défibrée porte « paille » dans son nom sans être la même
     marchandise : elle s'exclut de la famille au lieu de s'y ajouter. */
  { key: 'paille', label: '🌾 Paille', reconnait: (p) => p.includes('paille') && !estDefibree(p) },
  { key: 'defibree', label: '✂️ Paille défibrée', reconnait: estDefibree },
]

/* On lit la ligne « Produits » du formulaire et, si le devis a été rédigé,
   ses lignes. Pas le message libre : « surtout pas de paille » n'est pas
   une demande de paille.

   Le classement se fait produit par produit, jamais sur le texte entier :
   « Foin de Prairie, Paille défibrée » ne demande pas de paille en bottes,
   et une recherche à plat sur « paille » l'y rangerait pourtant. */
export function categoriesDe(q) {
  const ligneProduits = (q?.message || '').split('\n')
    .find((l) => l.trim().toLowerCase().startsWith('produits')) || ''
  const produits = [
    ...ligneProduits.replace(/^[^:]*:/, '').split(','),
    ...(Array.isArray(q?.lignes) ? q.lignes.map((l) => l?.produit || '') : []),
  ].map((x) => x.trim().toLowerCase()).filter(Boolean)

  return CATEGORIES
    .filter((c) => produits.some((p) => c.reconnait(p)))
    .map((c) => c.key)
}

/* Découpe le message du formulaire en paires « Clé : valeur ». */
export function parseDetails(message) {
  if (!message) return []
  const out = []
  let pendingKey = null
  let pendingVal = []
  const flush = () => {
    if (pendingKey) { out.push({ key: pendingKey, value: pendingVal.join('\n').trim() }); pendingKey = null; pendingVal = [] }
  }
  for (const raw of message.split('\n')) {
    const line = raw.trimEnd()
    const idx = line.indexOf(' : ')
    if (idx > 0 && idx < 40) {
      flush()
      pendingKey = line.slice(0, idx).trim()
      pendingVal = [line.slice(idx + 3).trim()]
    } else if (pendingKey) {
      pendingVal.push(line)
    }
  }
  flush()
  return out
}

export function getProduitsListe(q) {
  if (!q?.message) return ['votre produit']
  const match = q.message.match(/Produits\s*:\s*(.+)/i)
  if (!match) return ['votre produit']
  return match[1].split('\n')[0].trim().split(',').map((s) => s.trim()).filter(Boolean)
}

export function getQuantite(q) {
  if (!q?.message) return ''
  const match = q.message.match(/Quantité\s*:\s*(.+)/i)
  return match ? match[1].split('\n')[0].trim() : ''
}

export const isFourrage = (produit) => {
  const p = (produit || '').toLowerCase()
  return p.includes('foin') || p.includes('luzerne') || p.includes('prairie')
}

/* Taxe Fourrage : taxe douanière suisse, facturée au client et
   détaillée dans le mail. Saisie libre en CHF/100kg. */
export function calcLigne(l) {
  const p = parseFloat(l.poids) || 0
  const pr = parseFloat(l.prix) || 0
  const tx = parseFloat(l.taxe) || 0
  return { p, pr, tx, totalPrix: pr * p * 10, totalTaxe: tx * p * 10, total: (pr + tx) * p * 10 }
}

/* TVA française : enregistrée pour les statistiques sur les ventes aux
   clients français. Volontairement HORS du total et absente du mail —
   le devis reçu par le client est identique avec ou sans elle. */
export const TAUX_TVA = [5.5, 20]

export function tvaStat(l) {
  const pct = parseFloat(l.tvaPct) || 0
  if (!pct) return { pct: 0, parCent: 0, montant: 0 }
  const pr = parseFloat(l.prix) || 0
  const p = parseFloat(l.poids) || 0
  const parCent = (pr * pct) / 100
  return { pct, parCent, montant: parCent * p * 10 }
}

export const tvaTotaleDe = (lignes) => lignes.reduce((acc, l) => acc + tvaStat(l).montant, 0)

export const grandTotalOf = (lignes) => lignes.reduce((acc, l) => acc + calcLigne(l).total, 0)

/* Pied de page commun à tous les envois.

   Le corps d'un mailto: est du texte brut : impossible d'y poser un
   vrai lien. Les clients mail créent le lien eux-mêmes, à condition
   de reconnaître le motif — d'où une adresse et un numéro isolés sur
   leur propre ligne, chacun en début de ligne.

   Le numéro garde ses espaces, plus lisibles pour le client. La forme
   compacte se détecte un peu mieux dans certains webmails, mais pas
   au prix d'un numéro illisible dans tous les autres. */
export const PIED_CONTACT = `Pour toute question :
contact@fptransports.fr
+33 7 82 20 79 04 (téléphone et WhatsApp)

Bien cordialement,
Francky – achatpaille.com`

/* Date de livraison souhaitée par le client, au format ISO.

   Le formulaire du site nomme ce champ « Date souhaitée » ; le libellé
   « Date de livraison » existe aussi dans le code d'envoi, on accepte
   donc les deux plutôt que de parier sur un seul. */
export function dateLivraisonSouhaitee(q) {
  const brut = parseDetails(q?.message)
    .find((d) => /date\s*(souhait|de livraison)/i.test(d.key))?.value?.trim()
  if (!brut) return null
  const d = new Date(brut)
  return Number.isNaN(d.getTime()) ? null : d
}

const jour = (d) => d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })

/* Délai incompressible entre la validation et la livraison. */
const DELAI_MIN_JOURS = 7

/* Fenêtre annoncée sur le site pour les fourrages, sécheresse 2026. */
const ATTENTE_FOURRAGE = 'la mi/fin-septembre'

/* Paragraphe de livraison, adapté à ce que le client a demandé.

   Quatre situations, et un texte différent pour chacune : sans date il
   faut proposer, avec une date tenable il faut rassurer, avec une date
   trop proche il faut corriger sans braquer, et sur du fourrage la
   sécheresse impose la liste d'attente quelle que soit la date. */
export function phraseLivraison(q, lignes = [], phrases = null) {
  const souhaitee = dateLivraisonSouhaitee(q)
  const produits = lignes.length ? lignes.map((l) => l.produit) : getProduitsListe(q)
  const fourrage = produits.some(isFourrage)
  const auPlusTotDate = new Date(Date.now() + DELAI_MIN_JOURS * 24 * 60 * 60 * 1000)

  /* Un modèle peut fournir sa propre formulation pour le cas retenu.
     Le choix du cas reste au code : c'est lui qui connaît la date et
     la marchandise. */
  const surMesure = (cas) => {
    const texte = phrases?.[cas]?.trim()
    if (!texte) return null
    return texte
      .replace(/\{\{\s*date_souhaitee\s*\}\}/gi, souhaitee ? jour(souhaitee) : 'non précisée')
      .replace(/\{\{\s*date_au_plus_tot\s*\}\}/gi, jour(auPlusTotDate))
      .replace(/\{\{\s*attente_fourrage\s*\}\}/gi, ATTENTE_FOURRAGE)
  }

  if (fourrage) {
    return surMesure('fourrage') || `Délai de livraison : en raison de la sécheresse 2026 sur les fourrages et d'une forte demande, les livraisons de Foin et de Luzerne sont retardées.${souhaitee ? ` Votre souhait du ${jour(souhaitee)} ne pourra donc pas être tenu.` : ''} La validation de ce devis vous inscrit sur liste d'attente, avec une livraison à partir de ${ATTENTE_FOURRAGE}. Nous vous tiendrons informé dès qu'une date ferme pourra être fixée.`
  }

  const auPlusTot = auPlusTotDate

  if (!souhaitee) {
    return surMesure('sans_date') || 'Délai de livraison estimé : 3 à 7 jours minimum après validation, date de livraison fixée ensemble.'
  }
  if (souhaitee >= auPlusTot) {
    return surMesure('tenable') || `Délai de livraison : la date que vous souhaitez, le ${jour(souhaitee)}, est réalisable. Comptez 3 à 7 jours après validation ; nous confirmons ensemble le jour et le créneau.`
  }
  return surMesure('proche') || `Délai de livraison : la date que vous souhaitez, le ${jour(souhaitee)}, est trop proche pour être tenue — il faut compter 3 à 7 jours minimum après validation. Nous pouvons viser une livraison à partir du ${jour(auPlusTot)}, à confirmer ensemble.`
}

/* Corps du mail de devis. Texte identique à l'ancienne version. */
export function genererDevis(q, lignes) {
  const grandTotal = grandTotalOf(lignes)
  const quantite = getQuantite(q)
  const dateValide = new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
  const nomsProduits = lignes.map((l) => l.produit).join(', ')
  const hasFourrage = lignes.some((l) => isFourrage(l.produit))

  const detailLignes = lignes.map((l) => {
    const c = calcLigne(l)
    const f = isFourrage(l.produit)
    return `--- ${l.produit} ---
- Poids total approximatif : ${c.p > 0 ? c.p + ' T' : 'À définir'}
- Prix unitaire : ${c.pr.toFixed(2)} CHF/100kg
${f ? `- Taxe Fourrage : ${c.tx.toFixed(2)} CHF/100kg` : ''}
- Sous-total : ${c.totalPrix.toFixed(2)} CHF${f && c.tx > 0 ? ` + ${c.totalTaxe.toFixed(2)} CHF (Taxe Fourrage) = ${c.total.toFixed(2)} CHF` : ''}`
  }).join('\n\n')

  return `Bonjour ${q.name},

Vous nous avez sollicité pour une demande de devis de ${nomsProduits} et nous vous en remercions.

Voici notre offre indicative valable sous quinzaine (jusqu'au ${dateValide}) avant validation :
Quantité : ${quantite || 'À définir'} (Poids approximatif - 46 bottes / camion remorque, ticket de pesée lors de la livraison)

${detailLignes}

TOTAL GÉNÉRAL HT : ${grandTotal.toFixed(2)} CHF
(TVA non applicable - export Suisse)
${hasFourrage ? `
* Taxe Fourrage : Taxe douanière Suisse sur les produits de Foin et Fourrage, avec possibilité de réajustement chaque mois, s'il devait y avoir changement le jour de la livraison vous en seriez informé et les modifications seraient effectuées à la facturation, pour vérifier le montant imposé en douane le jour même nous pouvons vous communiquer les informations sur le site officiel des douanes Suisse.(xtares.admin.ch).
` : ''}
${phraseLivraison(q, lignes)}
Nous prenons en charge les formalités douanières.

🔍 Suivez l'avancement de votre devis en temps réel : ${lienSuivi(q)}

N'hésitez pas à revenir vers moi pour confirmer ou ajuster.

${PIED_CONTACT}`
}

/* ── Relances manuelles ────────────────────────────────────
   Deux boutons dans la fiche devis : WhatsApp et email. Rien
   n'est envoyé automatiquement, tu relis avant d'appuyer.   */

export const lienSuivi = (q) => `https://achatpaille.com/suivi-devis?q=${q.id}`

/* wa.me exige un numéro international sans + ni espaces.
   Un numéro commençant par 0 est traité comme suisse : le formulaire
   du site demande un canton, la clientèle est en Suisse. */
export function telInternational(phone) {
  if (!phone) return null
  const d = phone.trim().replace(/[^\d+]/g, '')
  if (!d) return null
  if (d.startsWith('+')) return d.slice(1)
  if (d.startsWith('00')) return d.slice(2)
  if (d.startsWith('0')) return `41${d.slice(1)}`
  return d
}

/* ── Recherche libre dans la liste ──
   On tape ce dont on se souvient d'un contact : un nom, un bout
   d'email, une localité, quelques chiffres du numéro. Les accents et
   la casse ne comptent pas : « zurich » trouve « Zürich ».          */
const sansAccents = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

/* Un numéro se tape de mémoire sous n'importe quelle forme : 079 123,
   +41 79 123, 0041 79… On compare chiffres contre chiffres, sur la
   forme internationale comme sur la forme nationale en 0. */
function formesTel(phone) {
  const intl = telInternational(phone)
  if (!intl) return []
  const formes = [intl, (phone || '').replace(/\D/g, '')]
  if (intl.startsWith('41') || intl.startsWith('33')) formes.push(`0${intl.slice(2)}`)
  return formes
}

export function correspondRecherche(q, recherche) {
  const brut = (recherche || '').trim()
  if (!brut) return true

  /* Que des chiffres (et leurs séparateurs) : c'est un numéro, qu'on
     compare d'un bloc — « 079 123 45 » ne se découpe pas en trois mots. */
  const chiffres = brut.replace(/\D/g, '')
  if (/^[\d\s+()./-]+$/.test(brut) && chiffres.length >= 3) {
    const sansZero = chiffres.replace(/^0+/, '')
    return formesTel(q.phone).some((f) => f.includes(chiffres) || (sansZero.length >= 3 && f.includes(sansZero)))
      || (q.message || '').includes(brut)   // un code postal, un numéro de devis…
  }

  /* Sinon chaque mot doit se retrouver quelque part : « dupont vaud »
     cherche un Dupont dans le canton de Vaud, pas l'un ou l'autre. */
  const texte = sansAccents([q.name, q.email, q.phone, q.message].filter(Boolean).join(' '))
  return sansAccents(brut).split(/\s+/).every((m) => texte.includes(m))
}

const prenomOu = (q) => (q.name || '').trim() || 'cher client'

export function whatsappRelance(q) {
  const tel = telInternational(q.phone)
  if (!tel) return null
  const texte = `Bonjour ${prenomOu(q)},

Votre devis achatpaille.com est prêt. Vous pouvez le consulter et suivre son avancement ici :
${lienSuivi(q)}

N'hésitez pas si vous avez une question ou si vous souhaitez ajuster la quantité.

Francky – achatpaille.com`
  return `https://wa.me/${tel}?text=${encodeURIComponent(texte)}`
}

export function mailRelance(q) {
  const produits = getProduitsListe(q).join(', ')
  const sujet = encodeURIComponent('Votre devis achatpaille.com est consultable')
  const corps = encodeURIComponent(
`Bonjour ${prenomOu(q)},

Nous vous avons transmis votre devis pour ${produits}.

Vous pouvez le consulter à tout moment et suivre son avancement en temps réel ici :
${lienSuivi(q)}

Si vous avez la moindre question, ou si vous souhaitez ajuster la quantité ou la date de livraison, répondez simplement à ce message.

${PIED_CONTACT}`)
  return `mailto:${q.email}?subject=${sujet}&body=${corps}`
}

/* Mail « demande bien reçue » déclenché au passage en statut `received`. */
export function mailDemandeRecue(q) {
  const nomComplet = (q.name || '').trim() || 'cher client'
  const lienSuivi = `https://achatpaille.com/suivi-devis?email=${encodeURIComponent(q.email)}`
  const sujet = encodeURIComponent('✅ Votre demande de devis a bien été reçue — Achat Paille')
  const corps = encodeURIComponent(
`Bonjour ${nomComplet},

Votre demande de devis a bien été reçue et elle sera traitée sous 24h ouvrées avec une offre personnalisée.

Vous pouvez suivre l'avancement de votre demande en temps réel ici :
${lienSuivi}

N'hésitez pas à nous contacter pour toute question.

Cordialement,
Francky - achatpaille.com`)
  return `mailto:${q.email}?subject=${sujet}&body=${corps}`
}

/* Rappel de la demande du client, repris tel qu'il l'a rempli.

   Les libellés viennent du formulaire du site : on les réutilise sans
   les réécrire, pour que le client reconnaisse ses propres mots. Le
   message libre est cité à part, à la fin, car c'est souvent le seul
   passage qu'il a rédigé lui-même. */
export function recapDemande(q) {
  const details = parseDetails(q?.message)
  const libre = details.find((d) => d.key.toLowerCase() === 'message')?.value?.trim()
  const champs = details.filter((d) => d.key.toLowerCase() !== 'message' && d.value?.trim())

  const date = q?.created_at
    ? new Date(q.created_at).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
    : null

  const lignes = [`Concernant votre demande de devis${date ? ` du ${date}` : ''} :`]
  champs.forEach((d) => lignes.push(`- ${d.key} : ${d.value.trim()}`))
  if (libre) lignes.push('', `Votre message : « ${libre} »`)
  return lignes.join('\n')
}

/* Mail libre : mêmes en-tête et signature que les autres envois, avec
   le corps laissé à écrire. Sert aux échanges qui ne sont pas un devis
   — une question, une relance particulière, un point sur une livraison. */
export function mailLibre(q) {
  const sujet = encodeURIComponent('achatpaille.com — votre demande')
  const corps = encodeURIComponent(
`Bonjour ${prenomOu(q)},

${recapDemande(q)}

ÉCRIRE VOTRE DEMANDE ICI

${PIED_CONTACT}`)
  return `mailto:${q.email}?subject=${sujet}&body=${corps}`
}

export function mailtoDevis(q, texte) {
  const sujet = encodeURIComponent(`Votre devis achatpaille.com — ${getProduitsListe(q).join(', ')}`)
  const corps = encodeURIComponent(texte)
  return `mailto:${q.email}?subject=${sujet}&body=${corps}`
}

/* ── Adresses ──────────────────────────────────────────────
   Le formulaire du site envoie « Canton », « Code postal » et
   « Localité » (dont le libellé public est « Localité / Adresse »,
   donc la rue s'y retrouve souvent).                        */

const RE_RUE = /localit|adresse/i
const RE_CP = /code\s*postal|\bnpa\b/i
const RE_CANTON = /canton/i

export const estChampAdresse = (key) => RE_RUE.test(key) || RE_CP.test(key) || RE_CANTON.test(key)

/* maps.apple.com ouvre Plans sur iPhone et Mac, et bascule sur la
   version web ailleurs. « Suisse » aide le géocodage à ne pas partir
   sur une commune française homonyme. */
export const mapsUrl = (adresse) =>
  `https://maps.apple.com/?q=${encodeURIComponent(`${adresse}, Suisse`)}`

/* Recompose l'adresse complète à partir des détails parsés. */
export function adresseDe(details) {
  const find = (re) => details.find((d) => re.test(d.key))?.value?.trim()
  const parts = [find(RE_RUE), find(RE_CP), find(RE_CANTON)].filter(Boolean)
  if (parts.length === 0) return null
  const texte = parts.join(', ')
  return { texte, url: mapsUrl(texte) }
}

/* ── Consultations avant / après l'envoi du devis ──────────
   `dates` : timestamps de consultation, du plus récent au plus ancien.
   Renvoie apres = null quand la date d'envoi est inconnue (devis
   partis avant l'ajout de la colonne devis_sent_at).          */
export function repartitionVues(dates, devisSentAt) {
  const total = dates?.length || 0
  if (!devisSentAt) return { total, avant: total, apres: null, dernierApres: null }
  const ref = new Date(devisSentAt)
  const apres = (dates || []).filter((d) => new Date(d) > ref)
  return {
    total,
    avant: total - apres.length,
    apres: apres.length,
    dernierApres: apres[0] || null,
  }
}

export const fmtDate = (d, opts) => new Date(d).toLocaleDateString('fr-FR', opts || { day: '2-digit', month: 'short', year: 'numeric' })
export const fmtDateTime = (d) => `${fmtDate(d)} à ${new Date(d).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
